import {
  CTP_PGA_S5,
  CTP_PGA_AUSTRALIA_S5,
  LONGEST_DRIVE_PGA_AUSTRALIA_S5,
  CTP_PGA_CANADA_S5,
  LONGEST_DRIVE_PGA_CANADA_S5,
  LONGEST_DRIVE_PGA_S5,
  AGGREGATE_CTP_S5,
  LONGEST_DRIVE_MEN_S5,
  LONGEST_DRIVE_WOMEN_S5,
  CTP_S5,
  CTP_EPSON_S5,
  LONGEST_DRIVE_EPSON_S5,
  CTP_WORLD_SERIES_S5,
  CTP_CHAMPIONSHIP_S5,
  LONGEST_DRIVE_WOMEN_CHAMPIONSHIP_S5,
  CTP_CHALLENGERS_S5,
  LONGEST_DRIVE_CHALLENGERS_S5,
} from "@/utils/constants";
import {
  getCurrency,
  getPrizeTable,
  getPurse,
  getTournamentType,
} from "@/utils/tournaments";
import CalculatePrize from "./CalculatePrize";
import PurseCard from "./PurseCard";
import FullPrizeList from "./FullPrizeList";

interface PurseSeason5Props {
  playersCount: number;
  tournamentName: string;
  tournamentId: string;
  inputVal: string;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PurseSeason5 = ({
  playersCount,
  tournamentName,
  tournamentId,
  inputVal,
  handleInputChange,
}: PurseSeason5Props) => {
  const type = getTournamentType(5, tournamentId, tournamentName);
  const currency = getCurrency(5, tournamentName);
  const purse = `${currency}${getPurse(
    5,
    tournamentId,
    tournamentName,
    playersCount,
  ).toLocaleString("en-US")}`;

  const prizeList = getPrizeTable(
    5,
    tournamentId,
    tournamentName,
    playersCount,
  );

  if (type.isEpsonS5) {
    return (
      <div className="flex justify-center">
        <div className="w-full min-[1041px]:!max-w-[965px]">
          <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-12.5">
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{purse}</span>
              <span className="text-xl text-tm-c-gray-300">Purse</span>
            </li>
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
              <span className="text-xl text-tm-c-gray-300">Players</span>
            </li>
          </ul>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-7.5">
            <CalculatePrize
              prizeList={prizeList}
              inputVal={inputVal}
              handleInputChange={handleInputChange}
            />
            <PurseCard title="Stroke play" prizeList={prizeList} />
            <PurseCard title={`CTP - All`} prizeList={CTP_EPSON_S5} />
            <PurseCard
              title={`Longest Drive`}
              prizeList={LONGEST_DRIVE_EPSON_S5}
            />
          </div>
          <FullPrizeList />
        </div>
      </div>
    );
  }

  if (type.isNextTourChampionshipS5) {
    return (
      <div className="flex justify-center">
        <div className="w-full min-[1041px]:!max-w-[965px]">
          <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-12.5">
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{purse}</span>
              <span className="text-xl text-tm-c-gray-300">Purse</span>
            </li>
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
              <span className="text-xl text-tm-c-gray-300">Players</span>
            </li>
          </ul>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-7.5">
            <CalculatePrize
              prizeList={prizeList}
              inputVal={inputVal}
              handleInputChange={handleInputChange}
            />
            <PurseCard title="Stroke play" prizeList={prizeList} />
            <PurseCard title={`CTP - All`} prizeList={CTP_CHAMPIONSHIP_S5} />
            <PurseCard title="Aggregate CTP" prizeList={CTP_CHAMPIONSHIP_S5} />
            <PurseCard
              title={`Longest Drive - Men\n`}
              prizeList={LONGEST_DRIVE_MEN_S5}
            />
            <PurseCard
              title={`Longest Drive - Women\n`}
              prizeList={LONGEST_DRIVE_WOMEN_CHAMPIONSHIP_S5}
            />
          </div>
          <FullPrizeList />
        </div>
      </div>
    );
  }

  if (type.isChallengersS5 || type.isPGAAustraliaS5 || type.isPGACanadaS5) {
    const ctpPrizes = type.isChallengersS5
      ? CTP_CHALLENGERS_S5
      : type.isPGACanadaS5
        ? CTP_PGA_CANADA_S5
        : CTP_PGA_AUSTRALIA_S5;
    const longestDrivePrizes = type.isChallengersS5
      ? LONGEST_DRIVE_CHALLENGERS_S5
      : type.isPGACanadaS5
        ? LONGEST_DRIVE_PGA_CANADA_S5
        : LONGEST_DRIVE_PGA_AUSTRALIA_S5;
    return (
      <div className="flex justify-center">
        <div className="w-full min-[1041px]:!max-w-[965px]">
          <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-12.5">
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{purse}</span>
              <span className="text-xl text-tm-c-gray-300">Purse</span>
            </li>
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
              <span className="text-xl text-tm-c-gray-300">Players</span>
            </li>
          </ul>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-7.5">
            <CalculatePrize
              prizeList={prizeList}
              inputVal={inputVal}
              handleInputChange={handleInputChange}
              currency={currency}
            />
            <PurseCard
              title="Stroke play"
              prizeList={prizeList}
              currency={currency}
            />
            <PurseCard
              title="CTP - All"
              prizeList={ctpPrizes}
              currency={currency}
            />
            <PurseCard
              title="Longest Drive - Men"
              prizeList={longestDrivePrizes}
              currency={currency}
            />
            <PurseCard
              title="Longest Drive - Women"
              prizeList={longestDrivePrizes}
              currency={currency}
            />
          </div>
          <FullPrizeList />
        </div>
      </div>
    );
  }

  if (type.isPGAAmericaS5) {
    return (
      <div className="flex justify-center">
        <div className="w-full min-[1041px]:!max-w-[965px]">
          <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-12.5">
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{purse}</span>
              <span className="text-xl text-tm-c-gray-300">Purse</span>
            </li>
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
              <span className="text-xl text-tm-c-gray-300">Players</span>
            </li>
          </ul>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-7.5">
            <CalculatePrize
              prizeList={prizeList}
              inputVal={inputVal}
              handleInputChange={handleInputChange}
            />
            <PurseCard title="Stroke play" prizeList={prizeList} />
            <PurseCard title="CTP - All" prizeList={CTP_PGA_S5} />
            <PurseCard
              title="Longest Drive - Men/Women"
              prizeList={LONGEST_DRIVE_PGA_S5}
            />
          </div>
          <FullPrizeList />
        </div>
      </div>
    );
  }

  return (
    //type.isOpenQualifierS5 || type.isNextWorldSeriesS5
    <div className="flex justify-center">
      <div className="w-full min-[1041px]:!max-w-[965px]">
        <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-12.5">
          <li className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">{purse}</span>
            <span className="text-xl text-tm-c-gray-300">Purse</span>
          </li>
          <li className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
            <span className="text-xl text-tm-c-gray-300">Players</span>
          </li>
        </ul>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-7.5">
          <CalculatePrize
            prizeList={prizeList}
            inputVal={inputVal}
            handleInputChange={handleInputChange}
          />
          <PurseCard
            title="Stroke play"
            prizeList={Array.from({ length: 5 }, (_, i) => prizeList?.[i] ?? 0)}
          />
          <PurseCard title="Aggregate CTP" prizeList={AGGREGATE_CTP_S5} />
          <PurseCard
            title="CTP - All"
            prizeList={type.isNextWorldSeriesS5 ? CTP_WORLD_SERIES_S5 : CTP_S5}
          />
          <PurseCard
            title="Longest Drive - Men"
            prizeList={LONGEST_DRIVE_MEN_S5}
          />
          <PurseCard
            title="Longest Drive - Women"
            prizeList={LONGEST_DRIVE_WOMEN_S5}
          />
        </div>
        <FullPrizeList />
      </div>
    </div>
  );
};

export default PurseSeason5;
